import $api from '../api';

const state = {
  current_points: 0,
  next_points_expiration: {}
};

const getters = {};

const actions = {
  getPoints: async ({ commit }, payload) => {
    const { data } = await $api.points.getPoints(payload);
    commit('setPoints', data);
  }
};

const mutations = {
  setPoints: (state, payload) => {
    state.current_points = payload?.current_points || 0;
    state.next_points_expiration = payload?.next_points_expiration || {};
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
